// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"acc42e50","644":"8ff90645"}[chunkId] + ".chunk.js";
};